import YearMonthPicker from '@/components/ezuro/workschedule/components/tools/YearMonthPicker.vue';
import MonthStatistics from '@/components/ezuro/workschedule/components/MonthStatistics.vue';

export default {
  name: 'Tools',
  props: {
    monthStats: {
      type: Object
    },
    values: {
      type: Object,
      default: function () {
        return {}
      }
    },
    enabledTools: {
      type: Array,
      default: function () {
        return [
          'YearMonthPicker',
          'Type',
          'Company',
          'Department',
          'Division',
          'Team',
          'Shift',
          'MonthStatistics'
        ]
      }
    },
    scheduleData: {
      type: Object | Array
    }
  },
  components: {
    YearMonthPicker,
    MonthStatistics
  },
  data () {
    return {
      editEl: {
        type: 'plan',
        company_id: [],
        department_id: [],
        division_id: [],
        team_id: [],
        shift_id: []
      },
      isLoading: false
    }
  },
  computed: {
    typeOptions () {
      if (!this.enabledTools.includes('Type')) return [];

      const types = [
        { value: 'plan', text: this.$t('work-schedule.type-options.plan') },
        { value: 'view', text: this.$t('work-schedule.type-options.view') },
        { value: 'track', text: this.$t('work-schedule.type-options.track') }
      ];

      return types;
    },
    companyOptions () {
      if (!this.enabledTools.includes('Company')) return [];

      const visibleCompanies = this.$session.get('visible_companies').map(Number);
      let options = this.BasicHelper.sortArrayByKeyValue(
        this.$store.getters.getConfigOptions(
          'user_companies',
          this.$i18n.locale,
          'disabled',
          '0'
        )
      );

      if (!this.ApiRequest.userHasPermission('ezuro-admin')) {
        options = options.filter(
          el => (
            visibleCompanies.includes(parseInt(el.value))
          )
        );
      }

      return options;
    },
    departmentOptions () {
      if (!this.enabledTools.includes('Department')) return [];

      const departments = this.$store.getters.getConfigOptions(
        'company_departments',
        this.$i18n.locale,
        null, null, false, false, false,
        ['company_id']
      ).filter(
        el => (
          this.editEl.company_id.includes(parseInt(el.company_id))
        )
      );

      return this.BasicHelper.sortArrayByKeyValue(departments, 'sortText');
    },
    divisionOptions () {
      if (!this.enabledTools.includes('Division')) return [];

      const divisions = this.$store.getters.getConfigOptions(
        'company_divisions',
        this.$i18n.locale,
        null, null, false, false, false,
        ['company_id', 'department_id']
      ).filter(
        el => (
          this.editEl.company_id.includes(parseInt(el.company_id)) &&
          (this.editEl.department_id === null || this.editEl.department_id.includes(parseInt(el.department_id)))
        )
      );

      return this.BasicHelper.sortArrayByKeyValue(divisions, 'sortText');
    },
    teamOptions () {
      if (!this.enabledTools.includes('Team')) return [];

      const teams = [];

      for (const key in this.scheduleData.teams) {
        teams.push({ value: this.scheduleData.teams[key].id, text: this.scheduleData.teams[key].name });
      }

      return teams;
    },
    shiftOptions () {
      if (!this.enabledTools.includes('Shift')) return [];

      const shifts = [];

      for (const key in this.scheduleData.shifts) {
        shifts.push({ value: this.scheduleData.shifts[key].id, text: this.scheduleData.shifts[key].name });
      }

      return shifts;
    }
  },
  methods: {
    filter: function (data) {
      if (data) {
        this.editEl.month = data.month;
        this.editEl.year = data.year;
      }

      if (this.editEl.company_id && !this.editEl.company_id.length) {
        this.editEl.department_id = [];
      }

      if (this.editEl.department_id && !this.editEl.department_id.length) {
        this.editEl.division_id = [];
      }

      this.$emit('filter', this.editEl);
    }
  },
  mounted () {
    for (const key in this.values) {
      this.editEl[key] = this.values[key];
    }
  }
}
